import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';

export const ClassicEditorContextProviderLoader = LoadablePaint({
	name: MustPreloadLoadableNames.ClassicEditorContextProviderLoader,
	loader: () =>
		import(
			/* webpackChunkName: "loadable-ClassicEditorContextProvider" */ './ClassicEditorContextProvider.js'
		),
});
